enum Modes {
    ABBREVIATED = 'abbreviated',
    CURRENCY = 'currency',
    DIGIT = 'digit',
    NUMBER = 'number',
}

export default Modes
